module.exports = __webpack_public_path__ + "static/media/dentist_explain.900b9b9e.jpg";